import { graphqlAjax } from '..'
import { gql } from 'apollo-boost'
import { buildVariablesWithAliases } from '@G/api/utils'

const reportSQL = `
data {
  year
  month
  day
  total_count
  total_success_count
}
meta {
  total
}
`

export default {
  getDailyReport: params => {
    const allStatus = Object.keys(params)
    const queryReducer = (acc, val, curr) => {
      return curr === 0
        ? `$filter_${val}: DailyOrderInput`
        : `${acc}, $filter_${val}: DailyOrderInput`
    }
    const resReducer = (acc, val) => {
      return `
        ${acc}
        ${val}: allDailyOrderStatistic(filter: $filter_${val}) {
          ${reportSQL}
        }
      `
    }

    const query = gql`
      query(${allStatus.reduce(queryReducer, '')}) {
        ${allStatus.reduce(resReducer, '')}
      }
    `

    const variables = {
      ...buildVariablesWithAliases(params)
    }
    return graphqlAjax('get', query, variables)
  }
}
